import { cn } from '@/utils/cn';
import { Icon } from '@/components/atoms/Icon';
import styles from './StatCard.module.scss';
import type { StatCardProps } from './StatCard.types';

/**
 * StatCard - Horizontal stat card for dashboard metrics
 * Nueva UI variant with horizontal layout (icon + info)
 *
 * @example
 * <StatCard
 *   icon={Goal}
 *   value="01"
 *   secondaryValue="/03"
 *   label="Weekly Story Goal"
 * />
 */
export function StatCard({
  icon,
  value,
  secondaryValue,
  compactSecondary,
  centerContent,
  surface = 'default',
  label,
  className,
}: StatCardProps) {
  return (
    <div
      className={cn(
        styles.statCard,
        !icon && styles['statCard--noIcon'],
        surface === 'sunken' && styles['statCard--surfaceSunken'],
        className
      )}
    >
      {icon && (
        <div className={styles.statCard__iconWrapper}>
          <Icon icon={icon} size="md" />
        </div>
      )}

      <div
        className={cn(styles.statCard__info, centerContent && styles['statCard__info--centered'])}
      >
        <div className={cn(styles.statCard__value, centerContent && styles['statCard__value--centered'])}>
          <span className={styles.statCard__valuePrimary}>{value}</span>
          {secondaryValue && (
            <span
              className={cn(
                styles.statCard__valueSecondary,
                compactSecondary && styles.statCard__valueSecondaryCompact
              )}
            >
              {secondaryValue}
            </span>
          )}
        </div>
        <p className={cn(styles.statCard__label, centerContent && styles['statCard__label--centered'])}>
          {label}
        </p>
      </div>
    </div>
  );
}

StatCard.displayName = 'StatCard';
